module.exports = __webpack_public_path__ + "static/media/map-marker.4bb65673.svg";